import BaseSidebar from './BaseSidebar';
import LeftSidebar from './LeftSidebar';
import RightSidebar from './RightSidebar';
import FullWidth from './FullWidth';
import RootLayout from './Root';
import WidgetsSidebar from './WidgetsSidebar';

export * from './Table';

export {
	RootLayout,
	BaseSidebar,
	LeftSidebar,
	RightSidebar,
	FullWidth,
	WidgetsSidebar
};

export default {
	RootLayout,
	BaseSidebar,
	LeftSidebar,
	RightSidebar,
	FullWidth,
	WidgetsSidebar
}